module.exports = __webpack_public_path__ + "img/sorry_2x.88afe36c.png";